// extracted by mini-css-extract-plugin
module.exports = {"container":"SettingsToggler_container__p2D3t"};